import { NgModule } from '@angular/core';
import { FuseConfirmDialogComponent } from './confirm-dialog.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        FuseConfirmDialogComponent
    ],
    imports: [
        
    ],
})
export class FuseConfirmDialogModule
{
}
